import React from 'react';
import { motion } from 'framer-motion';
import { PriceDisplay } from './PriceDisplay';
export function HeroSection() {
  const fadeUpVariants = {
    hidden: {
      opacity: 0,
      y: 28
    },
    visible: (custom: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: custom * 0.15,
        duration: 0.6,
        ease: 'easeOut'
      }
    })
  };
  return <section id="hero" className="relative pt-[70px] pb-[60px] px-5 text-center overflow-hidden" data-id="element-74">
      {/* Subtle radial gradient overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_50%_0%,rgba(233,30,140,0.12)_0%,transparent_70%)] pointer-events-none" data-id="element-75" />

      <div className="container-custom relative z-10" data-id="element-76">
        <motion.div custom={0} initial="hidden" animate="visible" variants={fadeUpVariants} className="inline-block bg-pink text-white text-xs font-bold tracking-[3px] uppercase py-[7px] px-5 rounded-full mb-[22px]" data-id="element-77">
          SOLO POR HOY · 8 CURSOS GRATIS · SOLO $14.999 ARS
        </motion.div>

        <motion.h1 custom={1} initial="hidden" animate="visible" variants={fadeUpVariants} className="font-bebas text-[clamp(50px,9vw,100px)] leading-[0.95] text-white tracking-[1px] max-w-[820px] mx-auto mb-5" data-id="element-78">
          CREA GELATINAS ARTÍSTICAS
          <em className="text-pink not-italic block" data-id="element-79">
            Y VÉNDELAS ESTA SEMANA.
          </em>
        </motion.h1>

        <motion.p custom={2} initial="hidden" animate="visible" variants={fadeUpVariants} className="text-[clamp(17px,2.5vw,22px)] text-muted max-w-[540px] mx-auto mb-9 font-light" data-id="element-80">
          El método completo para emprender desde casa en{' '}
          <strong className="text-text font-medium" data-id="element-81">7 días</strong> — sin
          experiencia, sin inversión enorme, sin complicaciones.
        </motion.p>

        <motion.div custom={3} initial="hidden" animate="visible" variants={fadeUpVariants} className="flex items-end justify-center gap-4 my-7" data-id="element-82">
          <PriceDisplay amount={14999} originalAmount={49999} size="lg" data-id="element-83" />
          <span className="text-[20px] text-muted pb-2" data-id="element-84">ARS</span>
        </motion.div>

        <motion.div custom={4} initial="hidden" animate="visible" variants={fadeUpVariants} data-id="element-85">
          <a href="[CART_LINK]" className="cta-primary" data-id="element-86">
            QUIERO MIS DISEÑOS →
          </a>
        </motion.div>

        <motion.div custom={5} initial="hidden" animate="visible" variants={fadeUpVariants} className="mt-5 text-[13px] text-muted flex items-center justify-center gap-5 flex-wrap" data-id="element-87">
          {['+1.200 emprendedoras', 'Acceso inmediato', 'Garantía 30 días'].map((text, i) => <span key={i} className="flex items-center gap-1.5" data-id="element-88">
                <svg viewBox="0 0 20 20" className="w-3.5 h-3.5 fill-green" data-id="element-89">
                  <path d="M10 1l2.4 6.9H20l-5.7 4.1 2.2 6.9L10 14.8 3.5 19l2.2-6.9L0 7.9h7.6z" data-id="element-90" />
                </svg>
                {text}
              </span>)}
        </motion.div>
      </div>
    </section>;
}